// store/thunks/packagingThunks.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchPackagingTypes } from "@services/packagingService";
import { getFromStorage, saveToStorage } from "@utils/storage";
import { PackagingType } from "types/packaging";

const PACKAGING_STORAGE_KEY = "packaging_data";
const CACHE_DURATION_DAYS = 3;

const isPackagingCacheValid = (
	data: PackagingType[] | null,
): data is PackagingType[] =>
	Array.isArray(data) &&
	data.every(
		(item) =>
			item &&
			"name_ru" in item &&
			"name_en" in item &&
			"name_tk" in item,
	);

export const fetchPackagingTypesThunk = createAsyncThunk<
	PackagingType[],
	void,
	{ rejectValue: string }
>("packaging/fetchAll", async (_, { rejectWithValue }) => {
	try {
		const cached = getFromStorage<PackagingType[]>(PACKAGING_STORAGE_KEY);
		if (isPackagingCacheValid(cached)) return cached;

		const result = await fetchPackagingTypes();
		saveToStorage(PACKAGING_STORAGE_KEY, result, false, CACHE_DURATION_DAYS);

		return result;
	} catch (error) {
		console.error("Error fetching packaging types:", error);
		return rejectWithValue("Failed to fetch packaging types.");
	}
});
